import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

import TokenVerification from './components/TokenVerification';
import Analytics from './components/Analytics';
import ThankYou from './components/ThankYou';
import TeamLogin from './components/cllteam/login';
import ClientLogin from './components/ClientLogin';
import Dashboard from './components/cllteam/dashboard'
import PendingCases from './components/cllteam/PendingCases';
import ReviewedCases from './components/cllteam/ReviewedCases';
import ClosedCases from './components/cllteam/ClosedCases';
import ToCall from './components/cllteam/toCall';
import ClientSearch from './components/cllteam/ClientSearch';
import RejectionReasons from './components/cllteam/RejectionReasons';
import Register from './components/cllteam/Register';
import Header from './components/header';
import Navbar from './components/cllteam/navbar';
import VideoPlayer from './components/UTLVideo';
import FileUpload from './components/cllteam/FileUpload';
import PauseFollowUps from './components/cllteam/PauseFollowUps';
import Maintenance from './components/Maintenance';

import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
	'pdfjs-dist/build/pdf.worker.min.mjs',
	import.meta.url,
).toString();

const ApplicationRoutes = () => {
  const { isAuthenticated, limitAccess, maintenanceMode } = useAuth();

  if (isAuthenticated && (!maintenanceMode || maintenanceMode === false)) {            
    return (
      <>
      <Navbar />
      <Routes>        
        <Route path="/" element={<TokenVerification />} />        
        <Route path="/to-call" element={<ToCall />}/>
        <Route path="/push-email" element={<ClientSearch />}/>
        {limitAccess === false ? (
          <>
          <Route path="/dashboard" element={<Dashboard />}/>
          <Route path="/pending-cases" element={<PendingCases />}/>          
          <Route path="/reviewed-cases" element={<ReviewedCases />}/>
          <Route path="/closed-cases" element={<ClosedCases />}/>
          <Route path="/rejection-reasons" element={<RejectionReasons />}/>        
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/explainer-video" element={<VideoPlayer />} />   
          <Route path="/file-upload" element={<FileUpload />} />
          <Route path="/pause-follow-ups" element={<PauseFollowUps />} />
          
          <Route path="*" element={<Analytics />}/>                              
          </>
        ) : (
          <Route path="*" element={<ClientSearch />}/>                              
        )}
      </Routes>
      </>
    )
  } else if (!isAuthenticated && (!maintenanceMode || maintenanceMode === false)) {    
    return (
      <Routes>
        <Route path="/" element={<TokenVerification />} />        
        <Route path="/thankyou" element={<ThankYou />} />
        <Route path="/login" element={<ClientLogin />} />
        <Route path="/dashboard" element={<TeamLogin />} />
        <Route path="/register" element={<Register />} />
        <Route path="/team-login" element={<TeamLogin />} />  
        <Route path="/explainer-video" element={<VideoPlayer />} />   
        <Route path="*" element={<ClientLogin />} />
        
      </Routes>
    )
  } else if (maintenanceMode === true) {    
    return (
      <Routes>
        <Route path="*" element={<Maintenance />} />
      </Routes>
    )
  }   
}


const App = () => {
  return (    
    <>
      <Header />      
      <div className="App">
        <AuthProvider>
          <Router>
            <ApplicationRoutes />
          </Router>
        </AuthProvider>        
      </div>    
    </>
  );
};

export default App;
